import React from 'react'

function Footer() {
    return (
        <>
            <footer className="app-footer">
                <div className="float-end d-none d-sm-inline">Anything you want</div>
                All rights reserved.
            </footer>
        </>
    )
}

export default Footer
